import { RaisedButton } from '@eduact/ed-components'
import {
	WalletAmanImage,
	WalletCodeImage,
	WalletFawryImage,
	WalletMasaryImage,
	WalletOpayImage,
	WalletPaymobImage,
	WalletVodafoneImage,
	FawryVodafoneImage,
	OpayVodafoneImage,
	MoneyHashFawryImage,
	MoneyHashCardImage,
	MoneyHashWalletImage,
	KashierCardImage,
	KashierWalletImage,
	ManualVcImage,
} from '@Components/Layout/Header/Assets/images'
import { useAppSelector } from '@Hooks/ReduxHooks'
import React, { useContext } from 'react'
import styled from 'styled-components'
import ButtonsGrid from '../../../../Layout/Header/Components/Wallet/ButtonsGrid'
import { WalletContext } from '../../../WalletContext'
import { TabBody } from '../Tabs.styled'
import { useTranslation } from 'react-i18next'

type Props = {}
const MethodsTab: React.FC<Props> = ({}) => {
	const { paymentMethods } = useAppSelector(state => state.settings)
	const { provider, setProvider, setWalletIndex } = useContext(WalletContext)
	const [t] = useTranslation(['wallet'])
	return (
		<TabWrapper>
			<MethodTabBody>
				<ButtonsGrid
					value={{
						value: provider?.provider,
						args: {
							method: provider?.method ?? 'aman',
						},
					}}
					onChange={value => {
						if (!value || !value.args) return
						if (value && value.value) {
							setProvider &&
								setProvider({
									method: value?.args?.method,
									provider: value.value,
								})
						}
					}}
				>
					{paymentMethods.manual_vc_enabled && (
						<ButtonsGrid.Item value={{ value: 'manual_vc', args: { method: 'ewallet' } }}>
							<ManualVcTile>
								<img alt={t('manual_vc.method')} src={ManualVcImage} />
							</ManualVcTile>
						</ButtonsGrid.Item>
					)}
					{paymentMethods.fawry_fawry && (
						<ButtonsGrid.Item value={{ value: 'fawry', args: { method: 'fawry' } }}>
							<img alt="Fawry" src={WalletFawryImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.credit_card_accept && (
						<ButtonsGrid.Item value={{ value: 'accept', args: { method: 'card' } }}>
							<img alt="Paymob" src={WalletPaymobImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.aman_accept && (
						<ButtonsGrid.Item value={{ value: 'accept', args: { method: 'aman' } }}>
							<img alt="Aman" src={WalletAmanImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.masary_accept && (
						<ButtonsGrid.Item value={{ value: 'accept', args: { method: 'masary' } }}>
							<img alt="Masary" src={WalletMasaryImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.ewallet_accept && (
						<ButtonsGrid.Item value={{ value: 'accept', args: { method: 'ewallet' } }}>
							<img alt="Vodafone" src={WalletVodafoneImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.ewallet_fawry && (
						<ButtonsGrid.Item value={{ value: 'fawry', args: { method: 'ewallet' } }}>
							<img alt="Vodafone" src={FawryVodafoneImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.ewallet_opay && (
						<ButtonsGrid.Item value={{ value: 'opay', args: { method: 'ewallet' } }}>
							<img alt="Vodafone" src={OpayVodafoneImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.credit_card_opay && (
						<ButtonsGrid.Item value={{ value: 'opay', args: { method: 'card' } }}>
							<img alt="Opay" src={WalletOpayImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.fawry_moneyhash && (
						<ButtonsGrid.Item value={{ value: 'moneyhash', args: { method: 'fawry' } }}>
							<img alt="MoneyHash Pay at Fawry" src={MoneyHashFawryImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.credit_card_moneyhash && (
						<ButtonsGrid.Item value={{ value: 'moneyhash', args: { method: 'card' } }}>
							<img alt="MoneyHash Card" src={MoneyHashCardImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.ewallet_moneyhash && (
						<ButtonsGrid.Item value={{ value: 'moneyhash', args: { method: 'ewallet' } }}>
							<img alt="MoneyHash e-Wallet" src={MoneyHashWalletImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.credit_card_kashier && (
						<ButtonsGrid.Item value={{ value: 'kashier', args: { method: 'card' } }}>
							<img alt="Kashier Card" src={KashierCardImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.ewallet_kashier && (
						<ButtonsGrid.Item value={{ value: 'kashier', args: { method: 'ewallet' } }}>
							<img alt="Kashier e-Wallet" src={KashierWalletImage} />
						</ButtonsGrid.Item>
					)}
					{paymentMethods.recharge_card && (
						<ButtonsGrid.Item value={{ value: 'eduact', args: { method: 'wallet' } }}>
							<img alt="Wallet Code" src={WalletCodeImage} />
						</ButtonsGrid.Item>
					)}
				</ButtonsGrid>
			</MethodTabBody>
			<RaisedButton
				onClick={() => {
					if (provider?.provider === 'eduact') {
						setWalletIndex?.(4)
						return
					}
					if (provider) {
						setWalletIndex?.(2)
					}
				}}
				disabled={!provider}
				width="100%"
			>
				{t('next')}
			</RaisedButton>
		</TabWrapper>
	)
}

export default MethodsTab

const TabWrapper = styled.div`
	/* padding: 0 1rem; */
`

// The manual VC art is square while every other tile is a wide banner;
// cap its height so the grid row it sits in stays close to the others.
const ManualVcTile = styled.div`
	display: flex;
	justify-content: center;
	img {
		max-height: 7rem;
		width: auto;
		border-radius: 3px;
	}
`

const MethodTabBody = styled(TabBody)`
	margin: 1rem 0;
	padding: 0;
	font-size: 0.8rem;
`
